module.exports = __webpack_public_path__ + "static/media/pyramid.82fe092b.png";